import script from "./AdminMasterclassEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMasterclassEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__